import { ButtonHeading, CommonModal } from "components";
import BootstrapTable from "components/BootstrapTable";
import MastersFilterModal from "modals/MastersFilterModal";
import React, { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import { FaRegTrashCan } from "react-icons/fa6";
import { FiEdit } from "react-icons/fi";
import { IoChevronBack, IoChevronForward } from "react-icons/io5";
import moment from "moment";
import { Link, useSearchParams } from "react-router-dom";
import { AiOutlineEye } from "react-icons/ai";
import { BsThreeDotsVertical } from "react-icons/bs";
import { MdCancel } from "react-icons/md";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { deleteUserData, getUserList } from "_services/userService";
import useDocumentTitle from "hooks/useDocumentTitle";
import { FaCheckCircle } from "react-icons/fa";
import { AddUserProfile, EditUserProfile } from "modals";
import {
  getExportSavedSifarish,
  getMasterData,
  getUserContact,
} from "_services";
import { StorageServices } from "utils";
import { IoMdDownload } from "react-icons/io";
import { RiMobileDownloadLine } from "react-icons/ri";

const User = () => {
  useDocumentTitle("User | MySifarish");
  const getMasterDataList = JSON.parse(localStorage.getItem("masterData"));
  const getUserData = JSON.parse(localStorage.getItem("userData"));
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [userListData, setUserListData] = useState([]);
  const [isDelete, setIsDelete] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const itemsPerPage = 20;
  const [isOpen, setIsOpen] = useState(false);
  const [addOpen, setAddOpen] = useState(false);
  const [isSuccessMsg, setIsSuccessMsg] = useState(false);
  const [userToEdit, setUserToEdit] = useState(null);
  const [loading, setLoading] = useState(false);
  const [exportLoad, setExportLoad] = useState(false);

  const debounceRefList = useRef(null);

  const [searchParams, setSearchParams] = useSearchParams();

  const initialFilter = {
    userId: "",
    birdId: "",
    page: 1,
    limit: 20,
    startDate: "",
    endDate: "",
    keyword: "",
    userRole: "",
    isActive: "",
  };

  const [filter, setFilter] = useState({
    ...initialFilter,
    userRole: searchParams.get("userRole")
      ? Number(searchParams.get("userRole"))
      : "",
    isActive:
      searchParams.get("isActive") === "true"
        ? true
        : searchParams.get("isActive") === "false"
        ? false
        : "",
    userId: searchParams.get("userId") || "",
    birdId: searchParams.get("birdId") || "",
    page: Number(searchParams.get("page")) || 1,
    limit: Number(searchParams.get("limit")) || 20,
    startDate: searchParams.get("startDate")
      ? moment(searchParams.get("startDate"))
      : "",
    endDate: searchParams.get("endDate")
      ? moment(searchParams.get("endDate"))
      : "",
    keyword: searchParams.get("keyword") || "",
  });

  const [selectedRange, setSelectedRange] = useState({
    startDate: filter.startDate,
    endDate: filter.endDate,
  });

  useEffect(() => {
    const params = {};

    Object.entries(filter).forEach(([key, value]) => {
      if (value !== "" && value !== null && value !== undefined) {
        params[key] = moment.isMoment(value)
          ? value.format("YYYY-MM-DD")
          : value;
      }
    });

    setSearchParams(params);
  }, [filter, setSearchParams]);

  const handleReset = () => {
    setFilter(initialFilter);
    setSearchParams({});
    setSelectedRange({ startDate: null, endDate: null });
  };

  const hasActiveFilters = Object.keys(initialFilter).some((key) => {
    if (key === "page" || key === "limit") return false;

    const currentValue = filter[key];
    const initialValue = initialFilter[key];

    const normalize = (val) =>
      val === "" || val === null || val === undefined ? null : val;

    const curr = normalize(currentValue);
    const init = normalize(initialValue);

    if (moment.isMoment(curr)) {
      return (
        curr.isValid() && (!moment.isMoment(init) || !curr.isSame(init, "day"))
      );
    }

    return curr !== init;
  });

  useEffect(() => {
    if (!getUserData?._id) return;

    if (debounceRefList.current) {
      clearTimeout(debounceRefList.current);
    }

    debounceRefList.current = setTimeout(() => {
      fetchlistUserData(getUserData._id);
    }, 500);

    return () => {
      if (debounceRefList.current) {
        clearTimeout(debounceRefList.current);
      }
    };
  }, [getUserData?._id, filter, selectedRange]);

  useEffect(() => {
    fetchCategory();
  }, []);

  const fetchCategory = async () => {
    try {
      const res = await getMasterData({ appVersion: "10.0.0" });
      if (res) {
        StorageServices.setLocalItem("masterData", JSON.stringify(res?.data));
      } else {
        toast.error(res?.responseMessage);
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
    }
  };

  const handlePageChange = (page) => {
    setFilter((s) => ({ ...s, page }));
  };

  const renderPagination = () => {
    const totalPages = Math.ceil(totalCount / itemsPerPage);
    const currentPage = filter.page;
    let pages = [];

    const createPageItem = (i) => (
      <li key={i} className={`page-item ${i === currentPage ? "active" : ""}`}>
        <a className="page-link _avPointer" onClick={() => handlePageChange(i)}>
          {i}
        </a>
      </li>
    );

    const rangeStart = Math.max(2, currentPage - 2);
    const rangeEnd = Math.min(totalPages - 1, currentPage + 2);

    pages.push(createPageItem(1));

    if (rangeStart > 2) {
      pages.push(
        <li key="dots-before" className="page-item disabled">
          <span className="page-link">...</span>
        </li>
      );
    }

    for (let i = rangeStart; i <= rangeEnd; i++) {
      pages.push(createPageItem(i));
    }

    if (rangeEnd < totalPages - 1) {
      pages.push(
        <li key="dots-after" className="page-item disabled">
          <span className="page-link">...</span>
        </li>
      );
    }

    if (totalPages > 1) {
      pages.push(createPageItem(totalPages));
    }

    return (
      <ul className="pagination">
        <li className={`page-item ${filter.page === 1 ? "disabled" : ""}`}>
          <a
            className="page-link _avPointer"
            onClick={() => handlePageChange(filter.page - 1)}
          >
            <IoChevronBack />
          </a>
        </li>
        {pages}
        <li
          className={`page-item ${
            filter.page === totalPages ? "disabled" : ""
          }`}
        >
          <a
            className="page-link _avPointer"
            onClick={() => handlePageChange(filter.page + 1)}
          >
            <IoChevronForward />
          </a>
        </li>
      </ul>
    );
  };

  const fetchlistUserData = async (data) => {
    setLoading(true);
    try {
      const payload = {
        ...filter,
        // startDate: moment(selectedRange.startDate).format("YYYY-MM-DD"),
        // endDate: moment(selectedRange.endDate).format("YYYY-MM-DD"),
        startDate: selectedRange.startDate
          ? moment(selectedRange.startDate).format("YYYY-MM-DD")
          : "",
        endDate: selectedRange.endDate
          ? moment(selectedRange.endDate).format("YYYY-MM-DD")
          : "",
        userId: data,
        birdId: filter?.birdId,
      };
      const res = await getUserList(payload);
      if (res) {
        setUserListData(res?.data?.users);
        setTotalCount(res?.data?.totalRecords);
      } else {
        toast.error(res?.responseMessage);
      }
      setLoading(false);
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
      setLoading(false);
    }
  };

  const handleDelete = (item) => {
    setIsDelete(item);
  };

  const submitDeleteUser = async () => {
    const payload = {
      userId: getUserData?._id,
      userIdToDelete: isDelete?._id,
    };
    try {
      const res = await deleteUserData(payload);
      if (res) {
        fetchlistUserData(getUserData._id);
        setIsDelete(false);
        setIsSuccessMsg(res?.message);
        toast.success(res?.message);
      } else {
        toast.error("Error !! ");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong");
      setIsDelete(false);
    }
  };

  const propsDelete = {
    isOpen: isDelete,
    closeModal: () => setIsDelete(false),
    modalMainClass: "confirmModal_new",
    footerPart: true,
    modalTitle: "Confirmation",
    submitTitle: "Confirm",
    cancelButtonTitle: "Close",
    onSubmit: submitDeleteUser,
  };

  const getUserRoleLabel = (role) => {
    switch (role) {
      case 1:
        return "User";
      case 2:
        return "Admin";
      case 3:
        return "Moderator";
      case 4:
        return "Business";
      default:
        return "-";
    }
  };

  function formatDateToDDMMYYYY(isoString) {
    if (!isoString) return "";

    const date = new Date(isoString);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  }

  const columns = [
    { header: "", accessor: "serial" },
    { header: "First Name", accessor: "firstName" },
    { header: "Last Name", accessor: "lastName" },
    { header: "Bird Name", accessor: "bird_name" },
    { header: "Sifarish Score", accessor: "sifarishPoints" },
    { header: "Phone no.", accessor: "phone_number" },
    { header: "Email", accessor: "emailId" },
    { header: "Location", accessor: "location" },
    { header: "Joined Date", accessor: "joined_date" },
    { header: "Forwarded Count", accessor: "forwardedCount" },
    { header: "Created Count", accessor: "createdCount" },
    { header: "Helpful Count", accessor: "helpfulCount" },
    { header: "Generation", accessor: "generation" },
    { header: "Status", accessor: "activeStatus" },
    { header: "Role", accessor: "userRole" },
  ];

  const rowListData = (data) =>
    data?.map((item, i) => ({
      ...item,
      serial: (
        <>
          <div className="d-flex gap-1 align-items-center">
            <div className="signDropdown">
              <button className="dropbtn11">
                <BsThreeDotsVertical />
              </button>
              <div className="dropdownContent">
                <Link
                  to={`/user/details/${item?._id}`}
                  state={{
                    storageBird: getMasterDataList?.birds,
                    listData: userListData,
                    currentIndex: i,
                  }}
                  className="_avPointer"
                  style={{ textDecoration: "none" }}
                >
                  <span className="_samAnchor">
                    <span className="viewIcon_avt">
                      <AiOutlineEye />
                    </span>{" "}
                    View
                  </span>
                </Link>

                <Link
                  className="_avPointer"
                  style={{ textDecoration: "none" }}
                  onClick={() => {
                    setUserToEdit(item);
                    setIsOpen(true);
                  }}
                >
                  <span className="_samAnchor">
                    <span className="viewIcon_avt">
                      <FiEdit />
                    </span>{" "}
                    Edit
                  </span>
                </Link>

                {item.userRole !== 2 && (
                  <div
                    className="_avPointer"
                    onClick={() => handleDelete(item)}
                  >
                    <span className="_samAnchor">
                      <span className="deleteIcon_avt">
                        <FaRegTrashCan color="red" />
                      </span>{" "}
                      Delete
                    </span>
                  </div>
                )}
              </div>
            </div>
            <div
              title="Download Saved Sifarish"
              className="__download_btn_list"
              onClick={() => exportSavedSifarishToCSV(item)}
            >
              <IoMdDownload />
            </div>
            <div
              title="Download User Contact"
              className="__download_btn_list"
              onClick={() => exportUserContactToCSV(item)}
            >
              <RiMobileDownloadLine />
            </div>
          </div>
        </>
      ),
      firstName: item?.firstName || "-",
      lastName: item?.lastName || "-",
      bird_name: item?.birdId?.title || "-",
      location: (
        <>
          {item?.city && item?.state && item?.country
            ? `${item?.city}, ${item?.state}, ${item?.country}`
            : "-"}
        </>
      ),
      phone_number: (
        <span>
          {`${item?.countryCode} ${item?.phoneNumber}` || "-"}
          {item?.isPhoneVerified ? (
            <FaCheckCircle style={{ marginLeft: "4px", color: "#08b231" }} />
          ) : (
            <MdCancel style={{ marginLeft: "4px", color: "#d62727" }} />
          )}
        </span>
      ),

      emailId: (
        <span>
          {item?.email || "-"}
          {item?.isEmailVerified ? (
            <FaCheckCircle style={{ marginLeft: "4px", color: "#08b231" }} />
          ) : (
            <MdCancel style={{ marginLeft: "4px", color: "#d62727" }} />
          )}
        </span>
      ),
      generation: <>{item?.generationId?.title}</>,
      activeStatus: item?.isActive ? "Active" : "Inactive",
      userRole: getUserRoleLabel(item?.userRole),
      joined_date: formatDateToDDMMYYYY(item?.createdAt),
    }));

  const exportToCSV = async () => {
    const loadingToast = toast.loading(
      "Please wait, Users data is getting exported..."
    );
    setExportLoad(true);

    try {
      const payload = {
        ...filter,
        userId: getUserData?._id,
        birdId: filter?.birdId,
        startDate: selectedRange.startDate
          ? moment(selectedRange.startDate).format("YYYY-MM-DD")
          : "",
        endDate: selectedRange.endDate
          ? moment(selectedRange.endDate).format("YYYY-MM-DD")
          : "",
        page: 1,
        limit: 1000,
      };

      const firstRes = await getUserList(payload);

      if (
        !firstRes ||
        !firstRes.data?.users ||
        firstRes.data.users.length === 0
      ) {
        toast.dismiss(loadingToast);
        toast.error("No data to export!");
        setExportLoad(false);
        return;
      }

      const totalPages = firstRes.data.totalPages || 1;
      const totalRecords =
        firstRes.data.totalRecords || firstRes.data.users.length;

      toast.dismiss(loadingToast);
      toast.success(
        `Exporting ${totalRecords} records in ${totalPages} chunks...`
      );

      let allData = [...firstRes.data.users];

      for (let page = 2; page <= totalPages; page++) {
        let success = false;
        let retries = 3;

        while (!success && retries > 0) {
          try {
            const res = await getUserList({ ...payload, page });
            if (res?.data?.users?.length) {
              allData = [...allData, ...res.data.users];
            }
            success = true;
          } catch (err) {
            console.warn(`Retrying page ${page}... (${3 - retries + 1})`);
            retries--;
            await new Promise((r) => setTimeout(r, 1000));
          }
        }
      }

      const chunkSize = 10000;
      const numFiles = Math.ceil(allData.length / chunkSize);

      for (let i = 0; i < numFiles; i++) {
        const chunk = allData.slice(i * chunkSize, (i + 1) * chunkSize);

        const filterSummary = [
          {
            Key: "User Role",
            Value:
              filter?.userRole === 1
                ? "User"
                : filter?.userRole === 2
                ? "Admin"
                : "All",
          },
          {
            Key: "Status",
            Value:
              filter?.isActive === true
                ? "Active"
                : filter?.isActive === false
                ? "Inactive"
                : "All",
          },
          {
            Key: "Bird",
            Value:
              getMasterDataList?.birds?.find(
                (opt) => opt._id === filter?.birdId
              )?.title || "All",
          },
          { Key: "Searched Word", Value: filter?.keyword || "-" },
          {
            Key: "Date Range",
            Value: selectedRange?.startDate
              ? `${moment(selectedRange.startDate).format(
                  "DD-MM-YYYY"
                )} - ${moment(selectedRange.endDate).format("DD-MM-YYYY")}`
              : "All Time",
          },
        ];

        const formattedData = chunk.map((user, index) => ({
          "Serial No": i * chunkSize + index + 1,
          "First Name": user?.firstName || "-",
          "Last Name": user?.lastName || "-",
          "Bird Name": user?.birdId?.title || "-",
          "Phone No.": user?.phoneNumber
            ? `${user?.countryCode} ${user?.phoneNumber}`
            : "-",
          Email: user?.email || "-",
          Location: `${user?.city || "-"}, ${user?.state || "-"}, ${
            user?.country || "-"
          }`,
          Status: user?.isActive ? "Active" : "Inactive",
          Role: getUserRoleLabel(user.userRole),
          "Joined Date": formatDateToDDMMYYYY(user?.createdAt) || "-",
          "Number Verified": user?.isPhoneVerified ? "Yes" : "No",
          "Email Verified": user?.isEmailVerified ? "Yes" : "No",
          "Forwarded Count": user?.forwardedCount || "-",
          "Created Count": user?.createdCount || "-",
          "Helpful Count": user?.helpfulCount || "-",
          "Sifarish Score": user?.sifarishPoints || "-",
          Generation: user?.generationId?.title || "-",
        }));

        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.json_to_sheet([], { skipHeader: true });

        const keyColumn = "C";
        const valueColumn = "E";

        ws[`${keyColumn}1`] = { t: "s", v: "Filter Type" };
        ws[`${valueColumn}1`] = { t: "s", v: "Filter Value" };

        filterSummary.forEach((item, index) => {
          const rowNum = index + 3;
          ws[`${keyColumn}${rowNum}`] = { t: "s", v: item.Key };
          ws[`${valueColumn}${rowNum}`] = { t: "s", v: item.Value };
        });

        XLSX.utils.sheet_add_json(ws, formattedData, {
          origin: "A9",
          skipHeader: false,
        });

        const dataOnly = formattedData.map((r) => r);
        XLSX.utils.sheet_add_json(ws, dataOnly, {
          origin: "A10",
          skipHeader: true,
        });

        ws["!cols"] = [
          { wch: 8 },
          { wch: 20 },
          { wch: 20 },
          { wch: 20 },
          { wch: 20 },
          { wch: 30 },
          { wch: 50 },
          { wch: 15 },
          { wch: 20 },
          { wch: 20 },
          { wch: 20 },
          { wch: 20 },
          { wch: 20 },
          { wch: 20 },
          { wch: 20 },
          { wch: 20 },
          { wch: 20 },
        ];

        XLSX.utils.book_append_sheet(wb, ws, `Users_${i + 1}`);

        const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const blob = new Blob([wbout], { type: "application/octet-stream" });
        const epochTime = Date.now();
        saveAs(blob, `Users_List_Part_${i + 1}_${epochTime}.xlsx`);
      }

      toast.success("All User data exported successfully!");
    } catch (error) {
      toast.dismiss(loadingToast);
      toast.error(error?.message || "Something went wrong during export.");
    } finally {
      setExportLoad(false);
    }
  };

  const exportSavedSifarishToCSV = async (UserData) => {
    try {
      const payload = {
        userId: getUserData?._id,
        userIdToRetrive: UserData?._id,
        page: 1,
        limit: -1,
      };

      const res = await getExportSavedSifarish(payload);

      if (
        !res ||
        !res.data?.savedSifarishes ||
        res.data.savedSifarishes.length === 0
      ) {
        toast.error("No data to export!");
        return;
      }

      const fullData = res.data.savedSifarishes;

      const formattedData = fullData.map((item, index) => ({
        "Serial No": index + 1,
        User: `${item?.sifarishId?.createdByUserId?.firstName || "-"} ${
          item?.sifarishId?.createdByUserId?.lastName || "-"
        }`,
        Bird: item?.sifarishId?.birdId?.title || "-",

        "User who saved": `${item?.fromUserId?.firstName || "-"} ${
          item?.fromUserId?.lastName || "-"
        }`,
        "Saved User Bird":
          getMasterDataList?.birds?.find(
            (opt) => opt._id === item?.fromUserId?.birdId
          )?.title || "-",
        Title: item?.sifarishId?.title || "-",
        Category: item?.sifarishId?.categoryId?.title || "-",
        SubCategories:
          item?.sifarishId?.categoryId?.subCategories?.length > 0
            ? item?.sifarishId?.categoryId?.subCategories
                ?.filter((sub) => sub?._id === item?.sifarishId?.subCategoryId)
                ?.map((sub) => sub.title)
                ?.join(", ")
            : "No Subcategories Available",
        Recommended: item?.isRecommended ? "Yes" : "No",
        "Sifarish Image":
          item.sifarishId?.mediaUrls?.length > 0
            ? item?.sifarishId?.mediaUrls[0]?.url
            : "No Image Available",
        City: item?.sifarishId?.address?.city || "-",
        State: item?.sifarishId?.address?.state || "-",
        Country: item?.sifarishId?.address?.country || "-",
      }));

      const wb = XLSX.utils.book_new();

      const ws = XLSX.utils.json_to_sheet(formattedData);

      ws["!cols"] = [
        { wch: 10 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 50 },
        { wch: 20 },
        { wch: 25 },
        { wch: 20 },
        { wch: 60 },
        { wch: 15 },
        { wch: 15 },
        { wch: 20 },
      ];

      XLSX.utils.book_append_sheet(wb, ws, "Saved Sifarish");

      const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const blob = new Blob([wbout], {
        type: "application/octet-stream",
      });

      const epochTime = Date.now();
      saveAs(blob, `Saved_Sifarish_List_${epochTime}.xlsx`);

      toast.success("Saved Sifarish exported successfully!");
    } catch (error) {
      toast.error(error?.message || "Something went wrong during export.");
    }
  };

  const exportUserContactToCSV = async (UserData) => {
    try {
      const payload = {
        userIdToFetch: UserData?._id || "",
        userId: getUserData._id || "",
        limit: -1,
        page: 1,
        keyword: "",
      };

      const res = await getUserContact(payload);

      if (!res || !res.data?.contacts || res.data.contacts.length === 0) {
        toast.error("No data to export!");
        return;
      }

      const fullData = res.data.contacts;

      const formattedData = fullData.map((item, index) => ({
        "Serial No": index + 1,
        "Contact Name": item?.contactName || "-",
        "Contact Number": item?.contactPhoneNumber || "-",
        "User Name":
          item?.userId === null
            ? "User Deleted"
            : `${item?.userId?.firstName} ${item?.userId?.lastName}`,

        Active: item?.isActive ? "Yes" : "No",
        Deleted: item?.isDeleted ? "Yes" : "No",
        Registered: item?.isRegistered ? "Yes" : "No",
        "Joined Date": formatDateToDDMMYYYY(item?.createdAt) || "-",
      }));

      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(formattedData);

      ws["!cols"] = [
        { wch: 10 },
        { wch: 30 },
        { wch: 20 },
        { wch: 30 },
        { wch: 10 },
        { wch: 10 },
        { wch: 12 },
        { wch: 20 },
      ];

      XLSX.utils.book_append_sheet(wb, ws, "Contact List");

      const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const blob = new Blob([wbout], { type: "application/octet-stream" });
      const epochTime = Date.now();
      saveAs(blob, `Contact_List_${epochTime}.xlsx`);
    } catch (error) {
      toast.error(error?.message || "Something went wrong during export.");
    }
  };

  const handleApply = (newRange) => {
    setSelectedRange(newRange);
    setFilter((s) => ({
      ...s,
      page: 1,
      startDate: newRange.startDate,
      endDate: newRange.endDate,
    }));
  };

  const EditUserModal = {
    isOpen,
    closeModal: () => setIsOpen(false),
    modalMainClass: "_dashCommon_Modal _mdModal",
    modalTitle: "Edit User",
    footerPart: true,
    submitTitle: "Update User",
    onSuccess: () => fetchlistUserData(getUserData._id),
  };

  const AddUserModal = {
    isOpen: addOpen,
    closeModal: () => setAddOpen(false),
    modalMainClass: "_dashCommon_Modal _mdModal",
    modalTitle: "Add User",
    footerPart: true,
    submitTitle: "Add User",
    onSuccess: () => fetchlistUserData(getUserData._id),
  };

  const handleOpenAdd = () => {
    setAddOpen(true);
  };

  return (
    <>
      <ButtonHeading
        title={"User"}
        showDateRange={true}
        Export={true}
        ExportSubmit={exportToCSV}
        exportLoad={exportLoad}
        selectedRange={selectedRange}
        filter={filter}
        setFilter={setFilter}
        handleApply={handleApply}
        isShow={{
          userRole: true,
          isActive: true,
          birds: true,
          keyword: true,
        }}
        handleReset={() => handleReset()}
        showResetFilter={hasActiveFilters}
        buttonTitle={"Add User"}
        onClick={() => handleOpenAdd()}
      />

      <div className="_tabWith_outTab">
        <BootstrapTable
          columns={columns}
          data={rowListData(userListData?.length > 0 ? userListData : [])}
          isLoading={loading}
          colSpan={16}
        />
        <div className="paginationFt_avt">{renderPagination()}</div>
      </div>

      <div
        className={`offcanvas offcanvas-end common_offCanvas ${
          showFilterModal ? "show" : ""
        }`}
        tabIndex={-1}
        style={{ visibility: showFilterModal ? "visible" : "hidden" }}
      >
        {showFilterModal && (
          <MastersFilterModal
            isOpen={showFilterModal}
            onClose={() => setShowFilterModal(false)}
            filter={filter}
            setFilter={setFilter}
          />
        )}
      </div>
      <div className={showFilterModal ? "offBack_drop" : ""}></div>

      {isOpen && userToEdit && (
        <EditUserProfile
          userId={getUserData?._id}
          userIdToUpdate={userToEdit._id}
          userData={userToEdit}
          props={EditUserModal}
        />
      )}

      {addOpen && <AddUserProfile props={AddUserModal} />}

      {isDelete?._id && (
        <CommonModal {...propsDelete}>
          <p className="p-3">
            {" "}
            Are you sure to delete this user {isDelete?.firstName}?
          </p>
        </CommonModal>
      )}
    </>
  );
};

export default User;
